import { Box, Stack, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';

// Components
import ExpandableBox from 'src/components/common/ExpandableBox';
import FlagCountry from 'src/components/common/FlagCountry';
import TableHorizontal from 'src/components/TableHorizontal';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { TypeBuyerSupplier } from 'src/utils/constants/enum';
import LinkToCompanyDetail from 'src/components/LinkToCompanyDetail';
import React from 'react';
import { useQueryParams } from 'src/hooks/useQueryParam';

// Utilities

const Supplier = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const queryParams = useQueryParams();
  const configColumn = [
    {
      label: 'Supplier',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.supplier_name),
      renderCell: (data: IBillOfLadingDetail) => (
        <LinkToCompanyDetail
          id={data?.supplier?.id}
          companyName={data?.supplier_name || ""}
          params={queryParams}
          viewedAsType={TypeBuyerSupplier.supplier}
        />
      ),
    },
    {
      label: 'Exporting Country',
      isShow: (data: IBillOfLadingDetail) =>
        !isEmpty(data?.supplier?.country_code) || !isEmpty(data?.supplier?.country_name),
      renderCell: (data: IBillOfLadingDetail) => (
        <Stack spacing={1} direction="row" alignItems="center">
          <FlagCountry code={data?.supplier?.country_code || ''} />
          <Typography color={'text.secondary'} variant="body2">
            {renderTextOrDefault(data?.supplier?.country_name)}
          </Typography>
        </Stack>
      ),
    },
    {
      label: 'Supplier Address',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.supplier?.jurisdiction),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderTextOrDefault(data?.supplier?.jurisdiction)}
        </Typography>
      ),
    },
  ];

  return (
    <ExpandableBox title="Supplier" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <TableHorizontal colKeyWidth={350} configColumn={configColumn} data={tradeDataDetail} />
      </Box>
    </ExpandableBox>
  );
};

export default Supplier;
